(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (() => {
    const form = document.getElementById('CustomerLoginForm');
    if (!form) return;

    const email = document.getElementById('CustomerEmail');
    const pass  = document.getElementById('CustomerPassword');
    const emailErr = document.getElementById('EmailError');
    const passErr  = document.getElementById('PasswordError');

    const show = (el, on) => { if (el) el.hidden = !on; };

    form.addEventListener('submit', (e) => {
      const emailEmpty = !email?.value?.trim();
      const passEmpty  = pass ? !pass.value : false;

      show(emailErr, emailEmpty);
      if (pass) show(passErr, passEmpty);

      if (emailEmpty || passEmpty) e.preventDefault();
    });

    email?.addEventListener('input', () => show(emailErr, !email.value.trim()));
    if (pass) pass.addEventListener('input', () => show(passErr, !pass.value));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  (() => {
    const form = document.getElementById('CustomerRegisterForm');
    if (!form) return;

    const policy = document.getElementById('RegisterForm-policy');
    const submit = document.getElementById('RegisterForm-submit');

    const toggleSubmit = () => {
      const enabled = !!policy?.checked;
      if (submit) {
        submit.disabled = !enabled;
        submit.setAttribute('aria-disabled', String(!enabled));
      }
    };

    toggleSubmit();
    policy?.addEventListener('change', toggleSubmit);

    form.addEventListener('submit', (event) => {
      if (!policy?.checked) {
        event.preventDefault();
        policy?.focus();
        return;
      }

      // セイとメイの値を取得
      const lastNameKana = document.getElementById('RegisterForm-LastNameKana')?.value || '';
      const firstNameKana = document.getElementById('RegisterForm-FirstNameKana')?.value || '';
      const noteField = document.getElementById('RegisterForm-Note');

      if (noteField && (lastNameKana || firstNameKana)) {
        // 顧客メモの形式を構築
        let noteContent = '●テーマからの登録\n';
        if (lastNameKana) {
          noteContent += `セイ：${lastNameKana}\n`;
        }
        if (firstNameKana) {
          noteContent += `メイ：${firstNameKana}`;
        }
        
        // 既存の顧客メモがある場合は、それを取得して処理
        // 注: Shopifyの標準フォームでは既存の顧客メモを取得できないため、
        // 新規登録時は上記の形式で設定します
        noteField.value = noteContent;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
